'use strict';

angular.module('webAgro1App').filter('formatCPF', function() {
  return function(value) {
    if (value) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
  };
});
